import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as NotifyActions from 'app/store/common-effects/notifier.effects';
import * as AssignedProjectsActions from 'app/store/login/assigned-projects/assigned-projects.actions';
import * as LoginActions from 'app/store/login/logged-user/logged-user.actions';
import * as CurrentProjectActions from 'app/store/project/current-project/current-project.actions';
import { TokenService } from 'core/http/lg-logistic-rest-api/Auth/token.service';
import { of } from 'rxjs';
import { catchError, exhaustMap, switchMap, tap } from 'rxjs/operators';
import * as RouterActions from '../../common-effects/router.effects';

@Injectable()
export class LoggedUserEffects {
  login$ = createEffect(() => this.actions$.pipe(
    ofType(LoginActions.logIn),
    exhaustMap(({ username, password }) => this.tokenService.obtain(username, password)
      .pipe(
        tap(token => localStorage.setItem('user', JSON.stringify(token))),
        switchMap(token => [
          LoginActions.logInSuccess({ token }),
          RouterActions.navigate({ path: ['/project'] }),
        ]),
        catchError(() => of(NotifyActions.errorNotify({ message: 'ERROR.authentication_failed' }))),
      )),
  ));

  refreshToken$ = createEffect(() => this.actions$.pipe(
    ofType(LoginActions.refreshToken),
    switchMap(({ token }) => this.tokenService.refresh(token).pipe(
      tap(newToken => localStorage.setItem('user', JSON.stringify(newToken))),
      switchMap(newToken => [
        LoginActions.logInSuccess({ token: newToken }),
        LoginActions.markRefreshing({ value: false }),
      ]),
      catchError(() => of(LoginActions.logout())),
    )),
  ));

  logout$ = createEffect(() => this.actions$.pipe(
    ofType(LoginActions.logout),
    tap(() => localStorage.clear()),
    switchMap(() => [
      AssignedProjectsActions.resetAssignedProjects(),
      CurrentProjectActions.resetCurrentProject(),
      LoginActions.resetLoggedUser(),
      RouterActions.navigate({ path: ['auth', 'login'] }),
    ]),
  ));

  constructor(
    private actions$: Actions,
    private tokenService: TokenService,
  ) { }
}
